import React from 'react';
import { Header2Text, NavigationItem } from 'ui-toolkit';

interface IAdminTitleProps {
  fullName: string;
  email: string;
}

export const AdminTitle: React.FC<IAdminTitleProps> = ({ fullName, email }) => (
  <div>
    <Header2Text>{fullName}</Header2Text>
    <NavigationItem href={`mailto:${email}`} text={email} isActive isInline />
  </div>
);
